// Tiny module-level registry so the service-worker update flow (see
// service-worker.ts) can ask "is the valet mid check-in right now?" without
// coupling to React or to any specific form. A dirty form means an
// auto-applied update (reload) would drop in-progress capture — see design
// decision D10 in sdd/pwa-offline-first/design.
let dirty = false;

export function setFormDirty(value: boolean): void {
  dirty = value;
}

export function isFormDirty(): boolean {
  return dirty;
}
